import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CartContext } from "components/cart";
import Product from "./Product";
import Axios from "axios";
import classNames from "lib/classNames";
import API from "../Api";
import { API_GATEWAY_NEW } from "aws-exports";
import useCampaign from "hooks/useCampaign";

const productsInMemory = {};

const AddToUnlock = ({ add_to_unlock, add_to_unlock_product_id }) => {
  const cartContext = useContext(CartContext);
  const {
    cart_settings: { theme, font },
    shopify_cart_items,
    campaigns,
    Utils,
    get_total,
    shop_url,
    isPreview,
    productNotAddedToCart,
    productAddedToCart,
    rechargeSettings,
    hasWriteDiscountsScope,
    products,
  } = cartContext;
  const [one_check_up_sell_product_id, ocu_campaign] = useCampaign(
    "one_check_up_sell",
    null,
    true
  )(campaigns, shopify_cart_items);
  const {
    borderColor,
    background,
    show_suggestions,
    recommendation_type = "custom_recommendation",
    products_length = 1,
    exclude_tags,
  } = add_to_unlock;
  const static_variants = window.monster_static?.variants;
  const [upSells, setUpSells] = useState([]);
  const filterUpsells = (value) => {
    return value.filter((product) => {
      if (productAddedToCart(product) || product.product_type === 'ship_protect') {
        return false;
      }
      const subscriptionObject = rechargeSettings?.products?.find((p) => {
        return Object.keys(p)[0] === product.id.toString();
      });
      const subscription = subscriptionObject && subscriptionObject[product.id];
      const { storefront_purchase_options } =
        subscription?.subscription_options || {};
      if (
        storefront_purchase_options &&
        storefront_purchase_options !== "subscription_and_onetime" &&
        storefront_purchase_options !== "onetime_only"
      ) {
        return false;
      }
      return true;
    });
  };
  const [allProducts, setAllProducts] = useState([]);
  const add_to_unlock_reward = add_to_unlock[add_to_unlock.reward_type];
  const handleSetAllProducts = (tmpProducts) => {
    setAllProducts(tmpProducts);
  };

  const fetchProducts = async (source, upsells) => {
    if (!upsells.length || upsells.every(({ fetched }) => fetched)) {
      return source.cancel();
    }
    try {
      const toBeFetched = [];
      let products = [];
      upsells.forEach(({ id }) => {
        const product = productsInMemory[id];
        if (product) {
          products.push(product);
        } else {
          toBeFetched.push(id);
        }
      });
      if (toBeFetched.length) {
        // const { data } = await Axios.get('https://mu-api.com/public/products', {
        //   params: {
        //     shopName: shop_url,
        //     productIds: toBeFetched 
        //   },
        //   cancelToken: source?.token,
        // });
        const { data } = await Axios.get(`${API_GATEWAY_NEW}/public/products`, {
          params: {
            shop: shop_url,
            ids: toBeFetched,
          },
          cancelToken: source?.token,
        });
        const fetchedProducts = Object.entries(data.products).reduce(
          (acc, [key, product]) => {
            if (!product) return acc;
            const data = { ...product, fetched: true };
            productsInMemory[key] = data;
            return acc.concat([data]);
          },
          []
        );
        products = products.concat(fetchedProducts);
      }
      setUpSells(filterUpsells(products));
      // // temporary send double product request
      // await Axios.get('https://mu-api.com/public/products', {params: {shopName: shop_url,productIds: toBeFetched }});
    } catch (e) {
      source.cancel();
    }
  };

  // set all possible poducts without the recommandations
  useEffect(() => {
    const tmpProducts = add_to_unlock.products.length
      ? add_to_unlock.products
      : isPreview
        ? Utils.fakePreviewProducts()
        : [];
    if (recommendation_type !== "shopify_recommendation")
      handleSetAllProducts(tmpProducts);
  }, [add_to_unlock.products, show_suggestions, recommendation_type]);

  // handle items change
  useEffect(() => {
    let tmpProducts = allProducts.filter((pro) => {
      const notAdded = productNotAddedToCart(pro);
      if (window.mu_custom_fbt_filter) {
        return window.mu_custom_fbt_filter(pro, products) && notAdded;
      }
      return notAdded;
    }).slice(0);
    if (show_suggestions && recommendation_type === "shopify_recommendation") {
      tmpProducts = tmpProducts
        .filter((prod) => checkTags(prod, exclude_tags))
        .splice(0, products_length);
    }

    if (rechargeSettings && !hasWriteDiscountsScope) {
      tmpProducts = filterUpsells(tmpProducts);
    }
    setUpSells(filterUpsells(tmpProducts));
  }, [
    shopify_cart_items,
    allProducts,
    show_suggestions,
    recommendation_type,
    products_length,
    exclude_tags,
    rechargeSettings,
    hasWriteDiscountsScope,
  ]);

  useEffect(() => {
    let tmpUpsel = (
      add_to_unlock.products.length
        ? add_to_unlock.products
        : isPreview
        ? Utils.fakePreviewProducts()
        : []
    ).filter((pro) => {
      const notAdded = productNotAddedToCart(pro);
      if (window.mu_custom_fbt_filter) {
        return window.mu_custom_fbt_filter(pro, products) && notAdded;
      }
      return notAdded;
    });
    setUpSells(filterUpsells(tmpUpsel));

    if (show_suggestions && recommendation_type == "shopify_recommendation") {
      if (isPreview) {
        API.get(`${API_GATEWAY_NEW}/public/products`, {
        params: { shop: shop_url, isPreview: true },
        })
        // API.get("https://mu-api.com/public/products", {
        //   params: { shopName: shop_url, isPreview: true },
        // })
          .then(({ data }) => {
            const { products } = data;
            let tmpProducts = parseProducts(products);
            handleSetAllProducts(tmpProducts);
          })
          .catch((error) => {
            API.get(`https://${shop_url}/products.json?limit=20`)
              .then(({ data }) => {
                const { products } = data;
                let tmpProducts = parseProducts(products);
                handleSetAllProducts(tmpProducts);
              })
              .catch((error) => {
                console.log(error);
              });
          });
        return; // TODO: return clean up function
      }
      const recoEndpoint = `/recommendations/products.json?product_id=${add_to_unlock_product_id}`;
      // const endpoint = 'https://shopquoteworthy.com/recommendations/products.json?product_id=5803024318625'
      // const recoEndpoint = '/recommendations/products.json?product_id=3320752701504'
      const productsEndpoint = "/products.json?limit=20";
      Axios.get(recoEndpoint).then(({ data }) => {
        const { products } = data;
        if (products) {
          if (products.length) {
            // map product and set it setAllProducts
            const tmpProducts = parseProducts(products);
            handleSetAllProducts(tmpProducts);
          } else {
            Axios.get(productsEndpoint).then(({ data: productsData }) => {
              const { products } = productsData;
              const tmpProducts = parseProducts(products);
              handleSetAllProducts(tmpProducts);
            });
          }
        }
      });
      //TODO: return clean up function
    }
  }, [show_suggestions, recommendation_type]);

  useEffect(() => {
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();
    fetchProducts(source, upSells);
    return () => {
      source.cancel();
    };
  }, [upSells]);

  const parseProducts = (products) => {
    const ocu_products = (ocu_campaign?.multi_one_check_upsell?.products || [])
      .map(({ product }) => product.id)
      .filter(Boolean)
      .map(String);
    return products
      .filter(({ id }) => !ocu_products.includes(id.toString()))
      .map((product) => {
        return {
          id: product.id,
          title: product.title,
          handle: product.handle,
          image: product.image,
          options: product.options,
          tags: product.tags,
          product_type:product.product_type,
          variants: product.variants.map((v) => {
            return {
              ...v,
              id: v.id,
              title: v.title,
              price: v.price / 100,
              image: v.featured_image ? v.featured_image.src : null,
            };
          }),
        };
      });
  };

  const checkTags = (product, tags = []) => {
    if (!tags) return true;
    return tags.every(
      (tag) =>
        !product.tags || (product.tags && product.tags.indexOf(tag) === -1)
    );
  };

  return upSells.length ? (
    <>
      {add_to_unlock.separator.active && (
        <div
          id="mu-fbt-separator"
          className={classNames("text-center my-3")}
          style={{
            lineHeight: "2px",
            background: Utils.formatColor(font.color, 0.28),
          }}
        >
          <span
            style={{
              background: Utils.formatColor(theme.background),
            }}
            className={classNames("px-2 font-bold")}
          >
            {add_to_unlock.separator.text}
          </span>
        </div>
      )}
      <div
        id="mu-fbt"
        className={classNames("frequently-container rounded border mb-2", {
          "mt-5": add_to_unlock.separator.active,
          "mt-1": !add_to_unlock.separator.active,
        })}
        style={{ borderColor: Utils.formatColor(borderColor) }}
      >
        <div
          className={classNames(
            "frequently-header text-center p-2 font-bold w-full"
          )}
          style={{
            background: Utils.formatColor(background),
            color: Utils.formatColor(add_to_unlock.title.color),
            fontSize: Utils.em(add_to_unlock.title.font_size),
            fontWeight: add_to_unlock.title.font_weight,
          }}
        >
          {add_to_unlock.title.text}
        </div>
        <div>
          {upSells.map((product) => {
            return (
              <Product
                key={product.id}
                product_info={product}
                add_to_unlock={add_to_unlock}
              />
            );
          })}
        </div>
      </div>
    </>
  ) : null;
};

// quotebujosandmore.myshopify.com/recommendations/products.json?product_id=36765506109601
// https://shopquoteworthy.com//recommendations/products.json?product_id=36765506109601

//3wizzystore.myshopify.com/recommendations/products.json?product_id=3431364624448

// 3431364624448
// const formateText = (text, rewardType, { type, reward, goal }, formatMoney, get_total) => {
// 	let replacedReward =
// 		rewardType === 'discount' ? (type === 'percentage' ? `${reward}%` : formatMoney(reward * 100)) : '';
// 	let replacedAmount = formatMoney(goal * 100 - get_total('original'));
// 	return text.replace('{{amount}}', replacedAmount).replace('{{reward}}', replacedReward);
// };

https: AddToUnlock.propTypes = {};

export default AddToUnlock;
